import React, {createContext, useContext, useEffect, useReducer} from "react";
import {useHistory, useParams} from "react-router-dom";
import {routesBase} from "v4/data/appRoutes";

export const IMPORT_STEP_1 = 'create-import';
export const IMPORT_STEP_2 = 'map-import';
export const IMPORT_STEP_3 = 'validate-import';
export const IMPORT_STEP_4 = 'process-import';
export const IMPORT_STEP_5 = 'complete-import';
export const IMPORT_STEP_FAILED = 'failed-import';
export const IMPORT_STEP_CANCELED = 'canceled-import';

const IMPORT_STEPS = [
    IMPORT_STEP_1,
    IMPORT_STEP_2,
    IMPORT_STEP_3,
    IMPORT_STEP_4,
    IMPORT_STEP_5,
];

const defaultContext = {
    currentStep: IMPORT_STEPS[0],
    nextStep: (currentImportId) => {
    },
    prevStep: () => {
    },
    selectedEntityType: null,
    updateSelectedEntityType: (entityType) => {
    },
};

export const importContext = createContext(defaultContext);

export function useImportContext() {
    return useContext(importContext);
}

function importReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_STEP':
            return {
                ...state,
                currentStep: action.payload,
            }
        case 'UPDATE_SELECTED_ENTITY_TYPE':
            return {
                ...state,
                selectedEntityType: action.payload,
            }
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}

export default function ImportContextProvider({children}) {
    const {push, replace} = useHistory();
    const {id: importId} = useParams();
    const [state, dispatch] = useReducer(importReducer, defaultContext, () => {
        return {
            ...defaultContext,
            ...(importId ? {currentStep: IMPORT_STEP_2} : {}),
        };
    });

    const updateStep = (step) => {
        if (step === IMPORT_STEP_1 || (step !== IMPORT_STEP_1 && !importId)) {
            replace(routesBase.adminDataImport);
        }

        dispatch({
            type: 'UPDATE_STEP',
            payload: step,
        });
    }
    const nextStep = (currentImportId) => {
        const currentIndex = IMPORT_STEPS.indexOf(state.currentStep);
        const nextIndex = currentIndex + 1;
        if ((state.currentStep === IMPORT_STEP_1 && !currentImportId) || nextIndex >= IMPORT_STEPS.length) return;


        updateStep(IMPORT_STEPS[nextIndex]);
        if (importId) return;
        push(`${routesBase.adminDataImport}/${currentImportId}`);
    }
    const prevStep = () => {
        const currentIndex = IMPORT_STEPS.indexOf(state.currentStep);
        const prevIndex = currentIndex - 1;
        if (prevIndex < 0) return;

        updateStep(IMPORT_STEPS[prevIndex]);
    }

    useEffect(() => {
        if (importId) return;

        updateStep(IMPORT_STEP_1);
        // eslint-disable-next-line
    }, [importId]);

    const updateSelectedEntityType = (entityType) => {
        dispatch({
            type: 'UPDATE_SELECTED_ENTITY_TYPE',
            payload: entityType,
        });
    }

    const contextToProvide = {
        ...state,
        nextStep,
        prevStep,
        updateStep,
        updateSelectedEntityType,
    };

    return (
        <importContext.Provider value={contextToProvide}>
            {children}
        </importContext.Provider>
    )
}
